var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hidden-sm-and-down"},_vm._l((_vm.links),function(link){return _c('v-btn',{key:link.name,attrs:{"text":"","router":"","exact":"","color":"black","to":link.route}},[_vm._v(_vm._s(link.name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }